import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SharedModule } from "src/app/shared/shared.module";

import { AddressComponent } from "./address";
import { NewCardComponent } from "./new-card/new-card.component";
import { NewBankComponent } from "./new-bank/new-bank.component";
import { NewBankDialogComponent } from "./new-bank-dialog/new-bank-dialog.component";
import { NewCardDialogComponent } from "./new-card-dialog/new-card-dialog.component";
import { MakeAPaymentComponent } from "./make-a-payment/make-a-payment.component";
import { PaymentSubmittedDialogComponent } from "./make-a-payment/payment-submitted-dialog/payment-submitted-dialog.component";
import { MakeAPaymentDialogComponent } from "./make-a-payment-dialog/make-a-payment-dialog.component";
import { PrintPaymentReceiptComponent } from "./make-a-payment/payment-submitted-dialog/print-payment-receipt/print-payment-receipt.component";
import { ErrorDialogComponent } from "../../components/error-dialog/error-dialog.component";
import { ChaseSuccessDialogComponent } from './make-a-payment/chase-success-dialog/chase-success-dialog.component';
import { PrintChaseReceiptComponent } from './make-a-payment/chase-success-dialog/print-chase-receipt/print-chase-receipt.component';
import { ChaseFailureDialogComponent } from './make-a-payment/chase-failure-dialog/chase-failure-dialog.component';
import { EditCardDialogComponent } from "./edit-card-dialog/edit-card-dialog.component";
import { EditBankDialogComponent } from "./edit-bank-dialog/edit-bank-dialog.component";




@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
  ],
  declarations: [
    AddressComponent,
    NewCardComponent,
    NewBankComponent,
    NewBankDialogComponent,
    NewCardDialogComponent,
    MakeAPaymentComponent,
    PaymentSubmittedDialogComponent,
    MakeAPaymentDialogComponent,
    PrintPaymentReceiptComponent,
    ChaseSuccessDialogComponent,
    PrintChaseReceiptComponent,
    ChaseFailureDialogComponent,
    EditCardDialogComponent,
    EditBankDialogComponent,

  ],
  entryComponents: [
    NewBankDialogComponent,
    NewCardDialogComponent,
    PaymentSubmittedDialogComponent,
    MakeAPaymentDialogComponent,
    ErrorDialogComponent,
    EditCardDialogComponent,
    EditBankDialogComponent,
    ChaseSuccessDialogComponent,
    PrintChaseReceiptComponent,
    ChaseFailureDialogComponent
  ]
})
export class ApsModule { }
